import styled from "styled-components";

export const LanguageToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;

  padding: 4px;
  margin-block: 15px;
  border: 1px solid rgba(156, 129, 98, 0.55);
  border-radius: 999px;

  background: rgba(253, 248, 242, 0.95);

  box-shadow: 0 4px 12px rgba(156, 129, 98, 0.2);
`;

export const LanguageButton = styled.button<{ $active: boolean }>`
  min-width: 46px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 13px;

  border: none;
  border-radius: 999px;

  background: ${({ $active }) =>
    $active ? "#9c8162" : "transparent"};

  color: ${({ $active }) =>
    $active ? "#ffffff" : "#5f5142"};

  font-family: "Quattrocento", serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.8px;

  cursor: pointer;

  transition:
    background-color 0.25s ease,
    color 0.25s ease,
    transform 0.2s ease,
    box-shadow 0.25s ease;

  box-shadow: ${({ $active }) =>
    $active
      ? "0 3px 8px rgba(156, 129, 98, 0.35)"
      : "none"};

  &:active {
    transform: scale(0.95);
  }
`;